export const queryConfig = {
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            refetchInterval: false,
            cacheTime: 1000,
            retry: false
        }
    }
}